module.exports = __webpack_public_path__ + "static/media/table.4efbd82e.png";